export default __webpack_public_path__ + "static/media/bg3.6212910a.png";